import { ISchema, ObjectSchema } from '@framework/validation';

export const ReferenceMetaKey = 'engineReference';

export function isReferenceSchema(schema: ISchema<any>) {
  return (
    schema instanceof ObjectSchema && schema.meta()?.[ReferenceMetaKey] === true
  );
}
